var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192 95.1471C212.698 88.5858 234.288 85.2754 256 85.3338C345.216 85.3338 405.931 138.667 442.134 185.686C460.267 209.28 469.334 221.035 469.334 256C469.334 290.987 460.267 302.742 442.134 326.315C405.931 373.334 345.216 426.667 256 426.667C166.784 426.667 106.07 373.334 69.867 326.315C51.7337 302.763 42.667 290.966 42.667 256C42.667 221.014 51.7337 209.259 69.867 185.686C80.9254 171.237 93.24 157.794 106.667 145.515",
    stroke: "white",
    strokeWidth: 32,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M320 256C320 272.974 313.257 289.253 301.255 301.255C289.253 313.257 272.974 320 256 320C239.026 320 222.747 313.257 210.745 301.255C198.743 289.253 192 272.974 192 256C192 239.026 198.743 222.747 210.745 210.745C222.747 198.743 239.026 192 256 192C272.974 192 289.253 198.743 301.255 210.745C313.257 222.747 320 239.026 320 256Z",
    stroke: "white",
    strokeWidth: 32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eyeIcon.df5a302f908b90b6a142224daac06112.svg";
export { ForwardRef as ReactComponent };